import { render, staticRenderFns } from "./AddressSetup.vue?vue&type=template&id=3b88ae0e"
import script from "./AddressSetup.vue?vue&type=script&lang=js"
export * from "./AddressSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports